module.exports = __webpack_public_path__ + "79a4a3f077e596293678ca8fd1fe25b4.MP3";